export enum PayPalIntegrationType {
    ClientSideREST,
    ServerSideREST,
}
